import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

@Component({
  selector: 'uretim-kaydi-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--uretim" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:9s;--x:10%;--y:20%"></span><span class="gc-p" style="--d:12s;--x:80%;--y:40%"></span><span class="gc-p gc-p--kucuk" style="--d:7s;--x:45%;--y:75%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">ÜRETİM KAYDI</div>
        <div class="uk-miktar">{{ p()?.miktar || 0 }} <span class="uk-label">ADET</span></div>
        <div class="uk-alt">
          @if (p()?.fire) { <span class="uk-fire">{{ p().fire }} fire</span> }
          @if (p()?.sure) { <span class="uk-sure">{{ p().sure }} dk</span> }
          @if (p()?.operator) { <span class="uk-op">{{ p().operator }}</span> }
        </div>
        @if (p()?.notlar) { <div class="uk-notlar">{{ p().notlar }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 75 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #1565c0; --accent-rgb: 21,101,192; }
    .uk-miktar { font-size: 24px; font-weight: 900; color: #42a5f5; font-variant-numeric: tabular-nums; text-shadow: 0 0 12px rgba(66,165,245,.3); }
    .uk-label { font-size: 10px; font-weight: 500; color: var(--py-metin-ikincil, #64748b); margin-left: 4px; }
    .uk-alt { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
    .uk-fire { font-size: 11px; font-weight: 700; color: #ef4444; }
    .uk-sure { font-size: 11px; font-weight: 600; color: #94a3b8; }
    .uk-op { font-size: 10px; font-weight: 500; color: var(--py-metin-ikincil, #64748b); }
    .uk-notlar { font-size: 10px; color: var(--py-metin-ikincil, #64748b); line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  `],
})
export class UretimKaydiKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
}
